// modules/inicio/components/AuthShell.js
// Marco compartido de las pantallas de acceso (login, registro, restablecer
// contraseña): panel azul informativo a la izquierda y formulario a la
// derecha. En celular el panel se compacta arriba del formulario.

import "../styles/auth.css";

export default function AuthShell({ kicker, titulo, texto, extra, children, estrecha }) {
  return (
    <div className="auth-wrap">
      <div className={`auth-card ${estrecha ? "estrecha" : ""}`}>
        <aside className="auth-lado">
          <div>
            <div className="auth-kicker">{kicker || "Secretaría de Salud del Amazonas"}</div>
            <h1>{titulo}</h1>
            {texto && <p>{texto}</p>}
            {extra}
          </div>
          <div className="auth-pie">Sistema Integrado de Promoción Social · 2026</div>
        </aside>
        <section className="auth-form">{children}</section>
      </div>
    </div>
  );
}
